import { render, staticRenderFns } from "./KioskAnalyticsPlatformStatistics.vue?vue&type=template&id=005d907f"
import script from "./KioskAnalyticsPlatformStatistics.vue?vue&type=script&lang=js"
export * from "./KioskAnalyticsPlatformStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports